export const skillsData = [
   // case 'html':
//    return html;
//    case 'css':
//      return css;
//    case 'angular':
//      return angular;
//    case 'javascript':
//      return javascript;
//    case 'react':
//      return react;
//    case 'bootstrap':
//      return bootstrap;
//    case 'mongodb':
//      return mongoDB;
//    case 'mysql':
//      return mysql;
//    case 'tailwind':
//      return tailwind;
//    case 'c':
//      return c;
//    case 'c++':
//      return cplusplus;
//    case 'java':
//      return java;
//    case 'aws':
//      return aws;
//    case 'git':
//      return git;
//    case 'numpy':
//      return numpy;
//    case 'figma':
//      return figma;
//    case 'microsoft office':
//      return microsoftoffice;
//    case 'canva':
//      return canva;
// write in this order
    'HTML',
    'CSS',
    'Angular',
    'JavaScript',
    'React',
    'Bootstrap',
    'MongoDB',
    'MySQL',
    'Tailwind',
    'C',
    'C++',
    'Java',
    'AWS',
    'Git',
    'NumPy',
    'Figma',
    'Microsoft Office',
    'Canva',


  ]
  